/* eslint-disable react/forbid-prop-types */
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";

const CardStepCompressed = ({
  cardHelpIcon,
  cardNumber,
  cardExpiration,
  cardSecurity,
  cardName
}) => {
  return (
    <div className="checkout__step-body">
      <div>
        <FontAwesomeIcon size="lg" icon={cardHelpIcon} className="me-1" />
        <span>
          {`**** **** **** ${cardNumber.slice(cardNumber.length - 4)}`}
        </span>
      </div>
      <div>{cardExpiration}</div>
      <div>{`***${cardSecurity.length === 4 ? "*" : ""}`}</div>
      <div>{cardName}</div>
    </div>
  );
};

export default CardStepCompressed;

CardStepCompressed.propTypes = {
  cardHelpIcon: PropTypes.object,
  cardNumber: PropTypes.string.isRequired,
  cardExpiration: PropTypes.string.isRequired,
  cardSecurity: PropTypes.string.isRequired,
  cardName: PropTypes.string.isRequired
};

CardStepCompressed.defaultProps = {
  cardHelpIcon: null
};
